// src/App.js
import React, { useState } from "react";
import AdminPanel from "./pages/AdminPanel";
import UserPanel from "./pages/UserPanel";
import UploadImg from "./pages/UploadImg";
import ImageManager from "./pages/ImageManager";
import Home from "./pages/Home";
import Terms from "./pages/Terms";

import Header from "./components/Header";
import HeaderAdmin from "./components/HeaderAdmin";
import Tail from "./components/Tail";
import Footer from "./components/Footer";
import Loader from "./components/Loader";
import LoginForm from "./components/LoginForm";
import EventsAdmin from "./components/EventsAdmin";
import ProtectedRoute from "./components/ProtectedRoute";

import { Container } from "react-bootstrap";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import { RiTailwindCssFill } from "react-icons/ri";
import { useEffect } from "react";

import api from "./api";
import HomeAdmin from "./pages/HomeAdmin";

function App() {
  const [event, setEvent] = useState({});
  const [page_name, setPageName] = useState("");
  const [authenticated, setAuthenticated] = useState(false);
  const [loadingAuth, setLoadingAuth] = useState(true);
  const [user, setUser] = useState(null);
  const [selectedE, setSelectedE] = useState(null);

  const checkAuth = async () => {
    try {
      const res = await api.get(`/auth/me`);
      setAuthenticated(res.data.authenticated);
      setUser(res.data.user);
    } catch {
      setAuthenticated(false);
      setUser(null);
    } finally {
      setLoadingAuth(false);
    }
  };

  useEffect(() => {
    checkAuth();
  }, []);

  const handleLogout = async () => {
    await api.post(`/auth/logout`, {}, { withCredentials: true });
    setAuthenticated(false);
  };

  const socialLinks = {
    instagram: event.user?.social_urls?.insta
      ? event.user.social_urls.insta
      : null,
    facebook: event.user?.social_urls?.fb ? event.user.social_urls.fb : null,
    website: event.user?.social_urls?.website
      ? event.user.social_urls.website
      : null,
  };

  // console.log("Social Links:", socialLinks);

  // useEffect(() => {
  //   document.body.style.backgroundImage = "url('/logo_only.jpg')";
  //   document.body.style.backgroundSize = 'cover';
  //   document.body.style.backgroundPosition = 'center';
  //   document.body.style.backgroundRepeat = 'no-repeat';
  //   document.body.style.backgroundAttachment = 'fixed';

  //   return () => {
  //     document.body.style.backgroundImage = '';
  //   };
  // }, []);

  return (
    <div className="p-1">
      <main
        className="main-content"
        style={{
          minHeight: "80vh",
        }}
      >
        {/* retrive the event Name from /check_eid endpoint */}
        <Router>
          {loadingAuth ? (
            <Loader iconPath="/favicon.png" size={100} />
          ) : (
            <Routes>
              <Route
                path="/login"
                element={
                  <>
                    <HeaderAdmin page_name={page_name} isAuthenticated={authenticated} />
                    <div className="d-flex justify-content-center align-items-center">
                      <LoginForm onLogin={checkAuth} />
                    </div>
                  </>
                }
              />
             <Route
                path="/admin"
                element={
                  <ProtectedRoute isAuthenticated={authenticated}>
                      <HeaderAdmin page_name="Home" isAuthenticated={authenticated} onLogout={handleLogout} user={user} />
                      <HomeAdmin user={user} />
                  </ProtectedRoute>
                }
              />
             <Route
                path="/admin/events"
                element={
                  <ProtectedRoute isAuthenticated={authenticated}>
                      <HeaderAdmin page_name="My Events" isAuthenticated={authenticated} onLogout={handleLogout} user={user} />
                      <EventsAdmin  user={user} selectedE={selectedE} />
                  </ProtectedRoute>
                }
              />

              {/* Route for the admin panel, e.g., http://localhost:3000/1/admin */}
              <Route
                path="/admin/:id_name"
                element={
                  <>
                  {/* <Header setEvent={setEvent} social_urls={socialLinks} /> */}
                  <ProtectedRoute isAuthenticated={authenticated}>
                  <HeaderAdmin page_name={page_name} setEvent={setEvent} isAuthenticated={authenticated} onLogout={handleLogout} user={user} />
                  <Container>
                    <div>
                    {event !== false ? (
                      event.name ? (
                        <AdminPanel
                          style={{ display: event.name ? "block" : "none" }}
                          event={event}
                          setPageName={setPageName}
                          setSelectedE={setSelectedE}
                        />
                      ) : (
                        // Loader
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            // height: "100vh",
                          }}
                        >
                          <Loader iconPath="/favicon.png" size={100} />
                        </div>
                      )
                    ) : (
                      <div>
                        <h2 className="text-center mb-4">Event Not Found</h2>
                      </div>
                    )}
                    </div>
                  </Container>
                  </ProtectedRoute>
                  </>
                }
                />

                              {/* Route for the admin panel, e.g., http://localhost:3000/1/admin/upload */}
              <Route
                path="/admin/upload/:id_name"
                element={
                  <>
                    <ProtectedRoute isAuthenticated={authenticated}>
                      <HeaderAdmin page_name={page_name} setEvent={setEvent} isAuthenticated={authenticated} onLogout={handleLogout} user={user} />
                      <UploadImg event={event} setPageName={setPageName} />
                    </ProtectedRoute>
                  </>
                }
              />




              <Route
                path="/event/:id_name"
                element={
                  <>
                    <Header setEvent={setEvent} social_urls={socialLinks} />
                    {/* <div className="align-items-center justify-content-center"> */}
                    <div className="">
                    {event !== false ? (
                      event.name ? (
                        <UserPanel
                          style={{ display: event.name ? "block" : "none" }}
                          event={event}
                        />
                      ) : (
                        // Loader
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            // height: "100vh",
                          }}
                        >
                          <Loader iconPath="/favicon.png" size={100} />
                        </div>
                      )
                    ) : (
                      <div>
                        <h2 className="text-center mb-4">Event Not Found</h2>
                      </div>
                    )}
                  {/* </div> */}
                  </div>
                  </>
                }
              />

              {/* Route for the admin panel, e.g., http://localhost:3000/1/admin */}
              <Route
                path="/event/:id_name/gallery"
                element={
                  <>
                    <Header setEvent={setEvent} social_urls={socialLinks} />
                  <Container className="">
                    <div>
                    {event !== false ? (
                      event.name ? (
                        <>
                          {/* show gallery is images found, else show now images found */}
                          <ImageManager event={event} />
                        </>
                      ) : (
                        // Loader
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            // height: "100vh",
                          }}
                        >
                          <Loader iconPath="/favicon.png" size={100} />
                        </div>
                      )
                    ) : (
                      <div>
                        <h2 className="text-center mb-4">Event Not Found</h2>
                      </div>
                    )}
                    </div>
                  </Container>
                  </>
                }
              />

              <Route path="/" element={<Home />} />
              <Route path="/terms" element={<Terms />} />
            </Routes>
          )}
        </Router>
      </main>
      {event.user?.social_urls ? <Footer social_urls={socialLinks} /> : null}
      <Tail></Tail>
    </div>
  );
}

export default App;
